import { BsFillVinylFill } from "react-icons/bs";
import {
  FaBuilding,
  FaMoneyBill,
  FaPeopleArrows,
  FaRegHandshake,
} from "react-icons/fa";
import { GiDrumKit } from "react-icons/gi";
import { useNavigate } from "react-router-dom";

const AnalyticsDashboard: React.FC = () => {
  const navigate = useNavigate();

  const actionItems = [
    { title: "Show Analytics", link: "/analytics/shows", icon: <GiDrumKit /> },
    // {
    //   title: "Release Analytics (Coming Soon)",
    //   link: "/analytics/recorded",
    //   icon: <BsFillVinylFill />,
    //   disabled: true,
    // },
    // {
    //   title: "Collaborator Analytics (Coming Soon)",
    //   link: "/analytics/collabs",
    //   icon: <FaPeopleArrows />,
    //   disabled: true,
    // },
    {
      title: "Artist Expenses (By Run)",
      link: "/analytics/runs/expenses",
      icon: <FaMoneyBill />,
      disabled: false,
    },
    {
      title: "Brand Deals",
      link: "/analytics/brand-deals",
      icon: <FaRegHandshake />,
      disabled: false,
    },
    {
      title: "Agent View",
      link: "/analytics/agent-view",
      icon: <FaBuilding />,
      disabled: false,
    },
  ];

  return (
    <div className="p-6">
      <div className="grid grid-cols-1 max-w-[900px] mx-auto">
        <h2 className="text-4xl text-center font-semibold mt-8 mb-4">
          Your Analytics Dashboards
        </h2>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 max-w-[900px] mx-auto">
        {actionItems.map((item, index) => (
          <div
            key={index}
            className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 aspect-square cursor-pointer"
          >
            <a
              onClick={() => (item.disabled ? null : navigate(item.link))}
              className="p-6 flex items-center justify-center h-full"
            >
              <div className="text-center">
                <div className="flex flex-col items-center">
                  <div className="text-5xl text-blue-500 mb-2">{item.icon}</div>
                  <h3 className="text-xl font-semibold">{item.title}</h3>
                </div>
              </div>
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AnalyticsDashboard;
